// Base URL of the Express auth backend. Set REACT_APP_AUTH_API_URL in production builds.
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || "http://localhost:3000";
